let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gzyRY")).then(() => parcelRequire('7XCnf'));